import { useState, useEffect } from 'react';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from 'config/ApiService';

export default function useV2(paramKey: string): string[] | null {
    const [paramValue, setParamValue] = useState<string[] | null>(null);

    useEffect(() => {
        // Set default settings for remote config
        remoteConfig.settings = {
            minimumFetchIntervalMillis: 3600000, // 1 hour
            fetchTimeoutMillis: 60000 // 1 minute
        };
        const fetchConfig = async () => {
            try {
                await fetchAndActivate(remoteConfig);
                const value = getValue(remoteConfig, paramKey).asString();
                const ids = value.split(',').map((id) => id.trim());
                setParamValue(ids);
            } catch (error) {
                console.error('Error fetching remote config:', error);
            }
        };
        fetchConfig();
    }, [paramKey]);

    return paramValue;
}
